import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';

import { RuleFlowType } from './Enums';

export interface IRuleFlow {
	typeName: RuleFlowType;
	referenceId: string;
}

export type RuleFlow = ReadonlyRecord<IRuleFlow>;

export const RuleFlowFactoryObject = Record<IRuleFlow>({
	typeName: null,
	referenceId: null
});

export const RuleFlowFactory = Record<IRuleFlow>({
	typeName: null,
	referenceId: null
});

export const RuleFlowFactoryFromJS = (data: IRuleFlow) =>
	RuleFlowFactory({
		typeName: data.typeName,
		referenceId: data.referenceId
	});
